(function () {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('doublon-company-management', {
                parent: 'admin',
                url: '/doublon-company-management?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Axenteev | Doublons'
                },
                views: {
                    'content@admin': {
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management.html',
                        controller: 'DoublonCompanyManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }]
                }
            })

            .state('doublon-company-management.delete', {
                parent: 'doublon-company-management',
                url: '/{name}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management-delete-dialog.html',
                        controller: 'DoublonCompanyManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompany', function (DoublonCompany) {
                                return DoublonCompany.get({ name: $stateParams.name });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('doublon-company-management.create', {
                parent: 'doublon-company-management',
                url: '/{name}/create',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management-create-dialog.html',
                        controller: 'DoublonCompanyManagementCreateController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompany', function (DoublonCompany) {
                                return DoublonCompany.get({ name: $stateParams.name });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('doublon-company-management.merge', {
                parent: 'doublon-company-management',
                url: '/{name}/merge',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-management-merge-dialog.html',
                        controller: 'DoublonCompanyManagementMergeController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompany', function (DoublonCompany) {
                                return DoublonCompany.get({ name: $stateParams.name });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('doublon-company-management.merge.db', {
                parent: 'doublon-company-management',
                url: '/{id}/mergeCompanyDB',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/doublon-company-management/doublon-company-db-management-merge-dialog.html',
                        controller: 'DoublonCompanyDBManagementMergeController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['DoublonCompanyDB', function (DoublonCompanyDB) {
                                return DoublonCompanyDB.get({ id: $stateParams.id });
                            }]
                        }
                    }).result.then(function () {
                        $state.go('doublon-company-management', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
